// Submission methods for submissions defined in
// https://docs.google.com/spreadsheets/d/1vSpSwC-3yg18-pltMsxRCIFpu795qrEy5XWTK7IM_m8/edit?usp=sharing
// Note: These values must match the Prisma enum values exactly

// Recipient types for submissions
export enum RecipientType {
  REGULATORY_AGENCY = "REGULATORY_AGENCY",
  THIRD_PARTY = "THIRD_PARTY",
  INTERNAL = "INTERNAL",
  OTHER = "OTHER",
}
